import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HelpService {

  public helpTitle = signal<string | null>(null);
  public helpContent = signal<string | null>(null);

  showHelp(helpTitle: string, htmlContent: string) {
    this.helpTitle.set(helpTitle);
    this.helpContent.set(htmlContent);
  }

  clearHelp() {
    this.helpTitle.set(null);
    this.helpContent.set(null);
  }

}
